<div class="row spacing-20">
  <div class="col-12">
    <div class="card">
      <div class="card-header border-0 pt-6 d-flex justify-content-between align-items-center">
        <h3 class="card-title fw-bold">
          <i class="fa fa-newspaper text-primary me-2"></i>{{ 'companyProfile.feed.title' | translate }}
        </h3>
        <app-button
          [label]="'companyProfile.feed.createPost' | translate"
          [variant]="'primary'"
          [iconClass]="'fa fa-plus'"
          (clicked)="openCreateModal()"
        />
      </div>
      <div class="card-body pt-0">
        <!-- Loading State -->
        @if (loading) {
          <div class="text-center py-10">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">{{ 'companyProfile.feed.loading' | translate }}</span>
            </div>
          </div>
        }

        <!-- Empty State -->
        @if (!loading && feedPosts.length === 0) {
          <div class="text-center py-15">
            <i class="fa fa-newspaper fs-3x text-muted mb-5"></i>
            <h4 class="text-muted">{{ 'companyProfile.feed.noPosts' | translate }}</h4>
            <p class="text-muted mb-5">{{ 'companyProfile.feed.noPostsHint' | translate }}</p>
            <app-button
              [label]="'companyProfile.feed.createPost' | translate"
              [variant]="'primary'"
              [iconClass]="'fa fa-plus'"
              (clicked)="openCreateModal()"
            />
          </div>
        }

        <!-- Feed Posts List -->
        @if (!loading && feedPosts.length > 0) {
          <div class="feed-posts-grid">
            @for (post of feedPosts; track post.feed_post_id) {
              <div class="feed-post-compact">
                <!-- Post Header -->
                <div class="d-flex justify-content-between align-items-start mb-2">
                  <div>
                    <h6 class="fw-bold mb-0">{{ post.title }}</h6>
                    <span class="text-muted fs-8">{{ formatDate(post.created_at) }}</span>
                  </div>
                  <div class="dropdown">
                    <button class="btn btn-sm btn-icon btn-light btn-xs" data-bs-toggle="dropdown">
                      <i class="fa fa-ellipsis-v fs-7"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li>
                        <a class="dropdown-item" (click)="openEditModal(post)">
                          <i class="fa fa-edit me-2"></i>{{ 'companyProfile.feed.edit' | translate }}
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item text-danger" (click)="deletePost(post)">
                          <i class="fa fa-trash me-2"></i>{{ 'companyProfile.feed.delete' | translate }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <!-- Post Description -->
                @if (post.description) {
                  <div class="post-description-compact" [innerHTML]="post.description"></div>
                }

                <!-- Post Images Gallery -->
                @if (post.images && post.images.length > 0) {
                  <div class="post-images-compact">
                    @if (post.images.length === 1) {
                      <div class="single-image-compact">
                        <img [src]="post.images[0].image_url" alt="Post image" (click)="openLightbox(post, 0)" />
                      </div>
                    } @else {
                      <div class="multi-images-compact">
                        @for (img of post.images; track img.image_id; let i = $index) {
                          @if (i < 3) {
                            <div class="gallery-image-compact" [class.more-overlay]="i === 2 && post.images.length > 3">
                              <img [src]="img.image_url" alt="Post image" (click)="openLightbox(post, i)" />
                              @if (i === 2 && post.images.length > 3) {
                                <div class="more-count-compact" (click)="openLightbox(post, 2)">
                                  +{{ post.images.length - 3 }}
                                </div>
                              }
                            </div>
                          }
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>

<!-- Create/Edit Modal -->
@if (showModal) {
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show d-block" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ editingPost ? ('companyProfile.feed.editPost' | translate) : ('companyProfile.feed.createPost' | translate) }}</h5>
          <button type="button" class="btn-close" (click)="closeModal()"></button>
        </div>
        <div class="modal-body">
          <div class="mb-4">
            <app-input-component
              [label]="'companyProfile.feed.postTitle' | translate"
              [placeholder]="'companyProfile.feed.postTitlePlaceholder' | translate"
              [type]="'text'"
              [(value)]="postTitle"
            />
          </div>
          <div class="mb-4">
            <app-markdown-editorini
              [value]="postDescription"
              (valueChange)="postDescription = $event"
            />
          </div>

          <!-- Image Upload Section -->
          <div class="mb-4">
            <label class="form-label fw-bold">{{ 'companyProfile.feed.images' | translate }}</label>

            <!-- Existing Images (when editing) -->
            @if (editingPost && editingPost.images && editingPost.images.length > 0) {
              <div class="existing-images mb-3">
                <p class="text-muted fs-7 mb-2">{{ 'companyProfile.feed.currentImages' | translate }}</p>
                <div class="d-flex flex-wrap gap-2">
                  @for (img of editingPost.images; track img.image_id) {
                    <div class="existing-image-thumb">
                      <img [src]="img.image_url" alt="Existing image" />
                      <button class="remove-btn" (click)="deleteImage(editingPost, img.image_id)">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                  }
                </div>
              </div>
            }

            <!-- New Image Upload -->
            <div class="upload-area">
              <input
                type="file"
                id="imageUpload"
                multiple
                accept="image/*"
                (change)="onImagesSelected($event)"
                class="d-none"
              />
              <label for="imageUpload" class="upload-label">
                <i class="fa fa-cloud-upload-alt fs-2x mb-2"></i>
                <span>{{ 'companyProfile.feed.clickToUpload' | translate }}</span>
              </label>
            </div>

            <!-- Selected Images Preview -->
            @if (selectedImages.length > 0) {
              <div class="selected-images mt-3">
                <p class="text-muted fs-7 mb-2">{{ 'companyProfile.feed.newImages' | translate }}</p>
                <div class="d-flex flex-wrap gap-2">
                  @for (preview of selectedImagePreviews; track preview; let i = $index) {
                    <div class="selected-image-thumb">
                      <img [src]="preview" [alt]="selectedImages[i].name" />
                      <button class="remove-btn" (click)="removeSelectedImage(i)">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
        <div class="modal-footer">
          <app-button
            [label]="'common.cancel' | translate"
            [variant]="'neutral'"
            (clicked)="closeModal()"
          />
          <app-button
            [label]="saving ? ('common.saving' | translate) : (editingPost ? ('companyProfile.feed.updatePost' | translate) : ('companyProfile.feed.createPost' | translate))"
            [variant]="'primary'"
            [disabled]="saving || !postTitle.trim()"
            (clicked)="savePost()"
          />
        </div>
      </div>
    </div>
  </div>
}

<!-- Lightbox -->
@if (showLightbox) {
  <div class="lightbox-overlay" (click)="closeLightbox()">
    <button class="lightbox-close" (click)="closeLightbox()">
      <i class="fa fa-times"></i>
    </button>
    <button class="lightbox-nav lightbox-prev" (click)="previousImage(); $event.stopPropagation()">
      <i class="fa fa-chevron-left"></i>
    </button>
    <div class="lightbox-content" (click)="$event.stopPropagation()">
      <img [src]="lightboxImages[lightboxIndex]" alt="Full size image" />
      <div class="lightbox-counter">
        {{ lightboxIndex + 1 }} / {{ lightboxImages.length }}
      </div>
    </div>
    <button class="lightbox-nav lightbox-next" (click)="nextImage(); $event.stopPropagation()">
      <i class="fa fa-chevron-right"></i>
    </button>
  </div>
}
